import { computed } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { classNames } from "@ember-decorators/component";
import DropdownSelectBoxComponent from "discourse/select-kit/components/dropdown-select-box";
import {
  pluginApiIdentifiers,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";
import { i18n } from "discourse-i18n";

@pluginApiIdentifiers("circles-members-dropdown-actions")
@selectKitOptions({
  icon: "wrench",
  showFullTitle: false,
})
@classNames("circles-members-dropdown-actions")
export default class MembersDropdownActions extends DropdownSelectBoxComponent {
  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    this.set("selectKit.isHidden", isEmpty(this.content));
  }

  @computed
  get content() {
    return [
      {
        id: "removeMember",
        name: i18n("discourse_circles.circle.members.remove_member"),
        description: i18n(
          "discourse_circles.circle.members.remove_member_description",
          {
            username: this.get("member.username"),
          }
        ),
        icon: "user-xmark",
        disabled: this.get("member.owner"),
      },
    ].filter((item) => !item.disabled);
  }
}
